export const divideAmount = (amount: number | string) => {
  const normalizedString = String(amount).replace(',', '.');

  const [integerPart, decimalPart] = normalizedString.split('.');

  const roundedDecimal =
    decimalPart && decimalPart.substring(0, 2) !== '00'
      ? decimalPart.substring(0, 2)
      : '';

  const formattedAmount = `${integerPart}${
    roundedDecimal ? `.${roundedDecimal}` : ''
  }`;

  const dividedAmount = formattedAmount.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  return dividedAmount.replace(/\u00A0/g, ' ');
};
